export default {
  shipments: {
    role: 'feature:shipments',
    displayName: 'Shipments'
  },
  globalShipments: {
    role: 'feature:global-shipments',
    displayName: 'Global shipments',
    description: 'Required for national user that are supposed to see inbound shipments'
  },
  packShipments: {
    role: 'feature:pack-shipments',
    displayName: 'Pack Shipments',
    description: 'User can move shipments to status packed'
  },
  lastMileDeliveries: {
    role: 'feature:lastMileDeliveries',
    displayName: 'Last Mile Deliveries',
    description: 'User can view last mile deliveries'
  },
  shipmentConfirm: {
    role: 'feature:shipment:confirm',
    displayName: 'Shipments: Confirm Delivery',
    description: 'User can tick items, edit quantities, and confirm shipments they are permitted to receive.'
  },
  shipmentPackImmediatePurchase: {
    role: 'feature:shipment:pack-immediate-purchase',
    displayName: 'Shipments: Pack Immediate Purchase',
    description: 'User can pack immediate_purchase shipments in their own market. Not granted by default: excluded for Operators at the Lagos and Nairobi DCs, where packing is handled through Shipsy instead.'
  }
}
